export default __webpack_public_path__ + "static/media/full-stack-development.7835ddbf.gif";